import React, { useMemo } from 'react';
import { useRouteMatch } from 'react-router';
import { EDIT_SESSION_RECORDINGS } from 'shared/constants/permissions';
import EmbedMatomo from 'containers/Results/WebsiteResults/EmbedMatomo';

const SessionRecording = () => {
  const match = useRouteMatch('/data-sources/:dataSourceId/hsr/session-recordings/:matomoHsrId');

  const urlParams = useMemo(() => ({
    category: 'HeatmapSessionRecording_SessionRecordings',
    subcategory: match.params.matomoHsrId,
  }), [match.params.matomoHsrId]);

  return (
    urlParams.subcategory ? <EmbedMatomo urlParams={urlParams} permission={EDIT_SESSION_RECORDINGS} /> : null
  );
};

export default SessionRecording;
